import React from "react";
import slider from "../../img/slider.png";
import "./Warrper.css";
import Hi from "../../img/icon/28-288401_waving-hand-emoji-svg-png-download-emoji-hand-removebg-preview.png";

const Slider = () => {
  return (
    <div className="max-w-[1100px] md:h-[700px] items-center flex md:flex-row flex-col justify-between  mx-auto">
      <div className="slider-items order-2 md:order-1 my-6 lg:my-2">
        <h4 className="uppercase mb-4 font-semibold text-2xl tracking-widest text-primary">
          <div className="warrper-container">
            <div className="warrper">MERN Stack Developer</div>
            <div className="warrper">ReactJS Developer</div>
            <div className="warrper">Front End Developer</div>
            <div className="warrper">Web Designer</div>
            <div className="warrper">Self Learner</div>
          </div>
        </h4>
        <h2 className="text-4xl mb-4 flex  font-bold">
          Hi
          <img src={Hi} alt="Hi-img" className="hand" />, I'm Md Tanvir Alam
        </h2>
        <div className="slider-btn flex">
          <button
            className="py-2 px-4 flex items-center  bg-primary text-white border-2 border-primary text-xl mr-2 lg:mr-6 rounded shadow-md
        
         "
          >
            Hire Me{" "}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 ml-2"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M17 8l4 4m0 0l-4 4m4-4H3"
              />
            </svg>
          </button>
          <a href="https://github.com/Tanvir-Alam625" target="_blank">
            <button
              className="py-2 px-4 border-2 border-primary flex items-center text-primary text-xl mr-2 rounded shadow-md
        
         hover:bg-primary duration-200 ease-in-out hover:text-white"
            >
              Learn More{" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 ml-2"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M17 8l4 4m0 0l-4 4m4-4H3"
                />
              </svg>
            </button>
          </a>
        </div>
      </div>
      <div className="slider-img order-1 md:order-2 my-8 md:my-0">
        <img
          src={slider}
          alt="slider"
          className="border-4   h-[300px] p-4  border-primary"
          style={{ borderRadius: "40px 0 40px 0" }}
        />
      </div>
    </div>
  );
};

export default Slider;
